module.exports = __webpack_public_path__ + "static/media/moonshot_logo.8e640972.svg";